module.exports = __webpack_public_path__ + "img/s_cyan_heart.9e97857d.png";